import mapEventProps from './mapEventProps';

/**
 * @param {TeaserEventApiProps} element
 * @returns {React.ComponentProps<typeof TeaserEvent>}
 */
const mapTeaserEventProps = (element) => mapEventProps(element.event);

export default mapTeaserEventProps;
